import React, {useEffect, useState} from 'react';
import {Link, useOutletContext, useParams, useSearchParams} from 'react-router-dom';
import TitleMain from "../../../components/Title/TitleMain";
import {useModal} from "../../../contexts/ModalContext";
import {useUser} from "../../../contexts/UserContext";
import AxiosConfig from "../../../services/AxiosConfig";
import {generateBreadcrumbSegmentsAdmin} from "../../../services/BreadcrumbService";
import {useBreadcrumb} from "../../../contexts/BreadcrumbContext";
import RoleCreation from "../../../components/Admin/Roles/RoleCreation";
import {getUtilisateurRoleLabel} from "../../../services/UserService";

function AdminRolePage() {
    const {user} = useUser();
    const {showModal, hideModal} = useModal();
    const [myApiData, setMyApiData] = useState([]);
    const {roleName} = useParams();
    const { updateDynamicBreadcrumb } = useBreadcrumb();
    const [role, setRole] = useState({});
    const [searchParams] = useSearchParams();
    const mode = searchParams.get('mode') || 'consultation';

    const handleSuccess = (children = "Note enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 1500});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 1500});
    };

    useEffect(() => {
        (async () => {
            try {
                const response = await AxiosConfig.get(`/admin/roles/${roleName}`);
                setMyApiData(response.data.myRole);
                setRole(response.data.myRole);
            } catch (error) {
                console.error('error', error);
            }
        })();
    }, [user]);

    useEffect(() => {
        updateDynamicBreadcrumb(generateBreadcrumbSegmentsAdmin({ role }));
    }, [role]);

    return (
        <div className="content">
            <TitleMain text={getUtilisateurRoleLabel(myApiData.role)}/>

            <RoleCreation role={myApiData} />
        </div>
    )
}

export default AdminRolePage;
